import React, {useState} from 'react';
import {Image} from "react-bootstrap"; // Optional for custom styling
import dashboardImage from "../../../../assets/img/dmarc-xml-header.webp"; // Optional for custom styling
import {useTranslation} from "react-i18next";
import {DMARCGeneratorForm} from "./DMARCGeneratorForm";
import {VideoEmbeder} from "../../../VideoEmbeder";
import appname from "../../../../appname";
import {routes} from "../../../../routes";
import {BookCallModal} from "../../common/BooKCallModal";
import {Helmet} from "@dr.pogodin/react-helmet";
import {StructuredContentService} from "../../../../service/SEO/StructuredContentService";
import {FAQ} from "../../common/FAQ";
import baseHostname from "../../../../hostname";
import {I18nService} from "../../../../service/i18nService";

export const DMARCGenerator = () => {
    const {t} = useTranslation();
    const list = t("pages.dmarcGenerator.whySettingUpIsANightMare.list", {returnObjects: true});
    const i18nService = new I18nService();
    const currentLang = i18nService.getLanguage();
    const [showModal, setShowModal] = useState(false);

    const mySelfWithLanguage = (lang) => `${appname}/${lang}/${routes['dmarcRecordGenerator'][lang]}`;
    const items = t('pages.dmarcGenerator.faq.list', {returnObjects: true});
    const schema = new StructuredContentService().generate(items, currentLang);

    const handleSendInfo = (e, generated, email, domain) => {
        e.preventDefault();
        fetch(
            baseHostname + '/index.php/fullreport',
            {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({source: "generator", result: generated, email, domain})
            })
            .then(res => res.ok ? res.json() : null)
            .then(data => {
                if (data) {
                    // TODO do stuff
                }
            })
            .catch(err => console.error('Submit error:', err));
    }
    return (
        <>
            <Helmet htmlAttributes={{lang: currentLang}}>
                <title>{t('pages.dmarcGenerator.meta.title')}</title>
                <meta name="description" content={t('pages.dmarcGenerator.meta.description')}/>
                <meta name="robots" content="index, follow"/>
                <link rel="canonical" href={mySelfWithLanguage(currentLang)}/>
                <meta property="og:title" content={t('pages.dmarcGenerator.meta.ogTitle')}/>
                <meta property="og:description" content={t('pages.dmarcGenerator.meta.description')}/>
                <meta property="og:type" content="website"/>
                <meta property="og:url" content={mySelfWithLanguage(currentLang)}/>
                <meta property="og:image"
                      content="https://dmarcflow.com/static/media/dmarc-flow-logo.d39195463fda1d6e5352.png"/>
                <meta name="twitter:card" content="summary_large_image"/>
                <meta name="twitter:title" content={t('pages.dmarcGenerator.meta.title')}/>
                <meta name="twitter:description" content={t('pages.dmarcGenerator.meta.description')}/>
                <meta name="twitter:image"
                      content="https://dmarcflow.com/static/media/dmarc-flow-logo.d39195463fda1d6e5352.png"/>
                <link rel="alternate" hrefLang="en" href={mySelfWithLanguage('en')}/>
                <link rel="alternate" hrefLang="de" href={mySelfWithLanguage('de')}/>
                <link rel="alternate" hrefLang="x-default" href={mySelfWithLanguage('en')}/>
                <script type="application/ld+json">{JSON.stringify(schema)}</script>
            </Helmet>

            <BookCallModal show={showModal} handleClose={() => setShowModal(false)}/>

            <div className="container-fluid">
                <div className={"row pt-5"} style={{backgroundColor: "#F5F7FF"}}>
                    <div className="col-12">
                        <div className="mb-5 text-center px-3">
                            <h1>{t("pages.dmarcGenerator.generator.title")}</h1>
                            <p className="lead">{t("pages.dmarcGenerator.generator.subTitle")}</p>
                        </div>
                    </div>
                </div>

                <div
                    className="row justify-content-center text-center py-5"
                    style={{backgroundColor: "#F5F7FF"}}
                >
                    <div className="col-12 col-md-10 col-lg-8 px-3">
                        <div className="alert alert-light p-4 shadow-sm rounded-4">
                            <p className="fw-bold fs-5">
                                🤯 {t("pages.dmarcGenerator.setupBlock.title")}
                            </p>
                            <p className="mb-4">
                                {t("pages.dmarcGenerator.setupBlock.subTitle")}
                            </p>
                            <ul className="list-unstyled mb-4">
                                <li className="mb-2">✅ {t("pages.dmarcGenerator.setupBlock.benefit1")}</li>
                                <li className="mb-2">✅ {t("pages.dmarcGenerator.setupBlock.benefit2")}</li>
                                <li className="mb-2">✅ {t("pages.dmarcGenerator.setupBlock.benefit3")}</li>
                            </ul>
                            <button
                                className="btn btn-primary btn-lg text-white"
                                onClick={() => setShowModal(true)}
                            >
                                {t("pages.dmarcGenerator.setupBlock.cta")}
                            </button>
                        </div>
                    </div>
                </div>
                <div className={"row d-flex justify-content-center pb-5"} style={{backgroundColor: "#F5F7FF"}}>
                    <div className="col-12 col-md-10 col-lg-8 px-4 px-md-2">
                        <DMARCGeneratorForm handleSendInfo={handleSendInfo}></DMARCGeneratorForm>
                    </div>
                </div>
                {/* Why DMARC is hard – value proposition section */}
                <div className="row justify-content-center pt-5 pb-5 bg-white" style={{backgroundColor: "#FEFEFF"}}>
                    <div className="col-12 col-md-10 col-lg-5 d-flex align-items-center justify-content-center px-4">
                        <VideoEmbeder videoId={"OQMia5Rvv7o"}></VideoEmbeder>
                    </div>
                    <div className="col-12 col-md-10 col-lg-5 p-4 p-lg-5">
                        <h3 className="mb-4">{t("pages.dmarcGenerator.whySettingUpIsANightMare.title")}</h3>
                        <p className="lead">
                            {t("pages.dmarcGenerator.whySettingUpIsANightMare.subTitle")}
                        </p>
                        <ul className="list-unstyled text-start mt-4 mb-4 mx-auto" style={{maxWidth: '700px'}}>
                            {list.map((item, index) => (
                                <li key={index} dangerouslySetInnerHTML={{__html: item}}/>
                            ))}
                        </ul>
                        <p className="mb-4">
                            {t("pages.dmarcGenerator.whySettingUpIsANightMare.underTitle")}
                        </p>
                        <button className="btn btn-primary btn-lg text-white" onClick={() => setShowModal(true)}>
                            {t("pages.dmarcGenerator.whySettingUpIsANightMare.cta")}
                        </button>
                    </div>
                </div>


                <div className={"row d-flex justify-content-center pt-5 pb-5"} style={{backgroundColor: "#F5F7FF"}}>
                    <div className="col-12 col-md-10 col-lg-5 p-4 p-lg-5">
                        <h4>{t("pages.dmarcGenerator.whatIsADmarcRecord.title")} </h4>
                        <p dangerouslySetInnerHTML={{__html: t("pages.dmarcGenerator.whatIsADmarcRecord.description")}}>
                        </p>
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h5 className="card-title fw-bold mb-3">
                                    🔧 {t("pages.dmarcGenerator.whatIsADmarcRecord.explanation.title")}
                                </h5>

                                <code className="d-block mb-4">
                                    {t("pages.dmarcGenerator.whatIsADmarcRecord.explanation.recordExample")}
                                </code>

                                <ul className="list-group list-group-flush mb-4">
                                    <li className="list-group-item">
                                        <strong>v=DMARC1:</strong> {t("pages.dmarcGenerator.whatIsADmarcRecord.explanation.entries.version")}
                                    </li>
                                    <li className="list-group-item">
                                        <strong>p=none:</strong> {t("pages.dmarcGenerator.whatIsADmarcRecord.explanation.entries.policy")}
                                    </li>
                                    <li className="list-group-item">
                                        <strong>rua:</strong> {t("pages.dmarcGenerator.whatIsADmarcRecord.explanation.entries.rua")}
                                    </li>
                                </ul>

                                <p className="mb-3">
                                    {t("pages.dmarcGenerator.whatIsADmarcRecord.explanation.whyNeeded")}
                                </p>

                                <p className="fw-bold mb-2">
                                    {t("pages.dmarcGenerator.whatIsADmarcRecord.explanation.benefitsTitle")}
                                </p>

                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item">✔️ {t("pages.dmarcGenerator.whatIsADmarcRecord.explanation.benefits.0")}</li>
                                    <li className="list-group-item">✔️ {t("pages.dmarcGenerator.whatIsADmarcRecord.explanation.benefits.1")}</li>
                                    <li className="list-group-item">✔️ {t("pages.dmarcGenerator.whatIsADmarcRecord.explanation.benefits.2")}</li>
                                </ul>
                            </div>
                        </div>
                        <div className={"mt-3"}>
                            <button onClick={() => setShowModal(true)} className="btn btn-primary w-100 text-white">
                                {t("pages.dmarcGenerator.pricing.cta")}
                            </button>
                        </div>

                    </div>
                    <div className="col-12 col-md-10 col-lg-5 d-flex align-items-center justify-content-center px-4">
                        <Image src={dashboardImage} alt={"dashboard"} className={"img-fluid w-75"}></Image>
                    </div>
                </div>

                <FAQ faqItems={items} title={t("pages.dmarcGenerator.faq.title")}
                     subTitle={t("pages.dmarcGenerator.faq.title")}></FAQ>

            </div>
        </>
    );
};
